import { useModalMultiple } from '@billy/design-system'
import { useCallback, useState } from 'react'
import { useMutation } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { queryClient } from '../../../config/queryClient'
import { ModalId } from '../../../enums/modalId'
import { QueryKeys } from '../../../enums/queryKeys'
import { getCurrentLocale } from '../../../utils'
import { localeToLanguage } from '../../../utils/localeToLanguage'
import { syncOpenBankingConnection } from '../query-api'

const RENEW_LOADING_DELAY_MS = 5000

export const useRenewOpenBankingConnection = () => {
  const [isRenewing, setIsRenewing] = useState(false)
  const locale = getCurrentLocale()
  const { organization } = useUserOrganization()
  const { open: openModal } = useModalMultiple([ModalId.BankConnectionErrorModal, ModalId.BankConnectionSuccessModal])

  const { mutate } = useMutation(
    (aiiaBankAccountId: string) =>
      syncOpenBankingConnection({
        aiiaBankAccountId,
        locale: localeToLanguage[locale],
        organizationId: organization?.id as string,
        redirectUrl: window.location.href,
      }),
    {
      onSuccess: () => {
        // wait to try to have fresh data when invalidating bank connections after renewal
        setTimeout(() => {
          setIsRenewing(false)
          queryClient.invalidateQueries(QueryKeys.OpenBankingAccounts)
          openModal(ModalId.BankConnectionSuccessModal)
        }, RENEW_LOADING_DELAY_MS)
      },
      onError: () => {
        setIsRenewing(false)
        openModal(ModalId.BankConnectionErrorModal)
      },
    },
  )

  const renewOpenBankingConnection = useCallback(
    (aiiaBankAccountId: string) => {
      setIsRenewing(true)
      mutate(aiiaBankAccountId)
    },
    [mutate],
  )

  return {
    isRenewing,
    renewOpenBankingConnection,
  }
}
